class StkUruntanimDTO {
    islemtanimId: number = null;
    barkodNo?: string = "";
    urungrupId?: number = null;
    olcubirimId?: number = null;
    ambalajbirimId?: number = null;
    ambalajbirimcarpan?: number = null;
    receteturId?: number = null;
    kullanimsekilId?: number = null;
    saklamakosulId?: number = null;
    riskgrupId?: number = null;
    aciklama?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    talepOlcubirimYontem?: number = null;
    ureticifirmaId?: number = null;
    marka?: string = "";
    testadi?: string = "";
    testgrupadi?: string = "";
    urunaltgrupadi?: string = "";
}
export default StkUruntanimDTO;